import { ReactElement, FC } from 'react'
import Head from 'next/head'

import { ILectur } from 'constants/types/common.types'
import { IMaterial } from 'constants/types/webinar.types'

const SEOWebinarFuture: FC<IMaterial> = ({
  name,
  startDate,
  seoDescription,
  Lecturs,
  linkTranslation,
}): ReactElement => {
  const areLectorsMany = Lecturs.length > 1

  const getLectorsName = () => {
    return Lecturs?.map((lector: ILectur) => {
      const { lastName, firstName, secondName } = lector

      return `${lastName} ${firstName} ${secondName}`
    })?.join(', ')
  }

  const data = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: name,
    startDate: startDate,
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    location: {
      '@type': 'VirtualLocation',
      url: `https://medpoint.pro/webinar/${linkTranslation}`,
    },
    description: seoDescription,
    performer: {
      '@type': areLectorsMany ? 'PerformingGroup' : 'Person',
      name: getLectorsName(),
    },
    organizer: {
      '@type': 'Organization',
      name: 'Medpoint',
      url: ' https://medpoint.pro/',
    },
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  )
}

export default SEOWebinarFuture
